/**
 *  @since 0.0.1
 */
export const ShowURI = 'ShowURI';
/**
 *  @since 0.0.1
 */
export class ShowType {
    constructor(show) {
        this.show = show;
    }
}
